import {
  Component, ViewContainerRef, ViewChild, Injector, ComponentFactoryResolver,
  Input, OnInit
} from '@angular/core';
import { Subscription } from 'rxjs';

import { DynamicBarService } from './dynamic-bar.service';
@Component({
    selector: 'dynamic-bar',
    standalone: false,
    template: '<div class="dinamico" #contenidoDinamico></div>',
    styleUrls: ['dynamic-bar.component.scss'],

})
export class DynamicBarComponent implements OnInit {
  private saving = false;
  subscription: Subscription;
  showBar = false;

  currComponent = null;
  @ViewChild('contenidoDinamico', { read: ViewContainerRef, static: true }) contenidoDinamico: ViewContainerRef;

  // component: Class for the component you want to create
  // inputs: An object with key/value pairs mapped to input name/input value
  @Input()
  set topBarData(data: { component: any, inputs: any }) {
    if (!data) {
      return;
    }

    // Inputs need to be in the following format to be resolved properly
    const inputProviders = Object.keys(data.inputs).map((inputName) => {
      return { provide: inputName, useValue: data.inputs[inputName] };
    });
    // let resolvedInputs = ReflectiveInjector.resolve(inputProviders);

    // We create an injector out of the data we want to pass down and this components injector
    const injector = Injector.create({ providers: [inputProviders] });
    // let injector = Injector.create(inputProviders, this.contenedorDinamico.parentInjector);

    // We create a factory out of the component we want to create
    const factory = this.resolver.resolveComponentFactory(data.component);

    // We create the component using the factory and the injector
    const component = factory.create(injector);

    // We insert the component into the dom container
    this.contenidoDinamico.insert(component.hostView);

    // Destroy the previously created component
    if (this.currComponent) {
      this.currComponent.destroy();
    }

    this.currComponent = component;

    this.showBar = true;
  }

  constructor(private resolver: ComponentFactoryResolver,
    private dynamicBarService: DynamicBarService) {

  }

  ngOnInit() {
    this.dynamicBarService.getDynamicBarObservable().subscribe(data => {
      if (!data) {
        return;
      }

    });
  }
}
